import { GRETA_PROJECTS_VISIBLE_LIMIT } from '../../GretaAIChat.constants'
import { getHasGretaAIChatProjectChat } from '../../GretaAIChat.utils.projects'

export function getHasGretaAIChatProjectsBeyondLimit(projects) {
  return projects.length > GRETA_PROJECTS_VISIBLE_LIMIT
}

export function getHasGretaAIChatHiddenProjects(hiddenProjectsCount) {
  return hiddenProjectsCount > 0
}

export function getGretaAIChatVisibleProjects({
  activeChatId,
  isAllShown,
  projects,
}) {
  return isAllShown
    ? projects
    : projects.filter(
        (project, index) =>
          index < GRETA_PROJECTS_VISIBLE_LIMIT ||
          getHasGretaAIChatProjectChat(project.chats, activeChatId)
      )
}
